import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigurationService, OidcSecurityService, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { Observable, switchMap } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private configurationService: ConfigurationService = inject(ConfigurationService);
  private auth: OidcSecurityService = inject(OidcSecurityService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const allConfigurations: OpenIdConfiguration[] = this.configurationService.getAllConfigurations();
    const flatSecureRoutes: string[] = this.flatten(
      allConfigurations.map((config: OpenIdConfiguration): string[] => config.secureRoutes ?? []),
    );
    const matchingConfig: OpenIdConfiguration | null = this.findMatchingConfig(req.url, allConfigurations);

    return this.auth.getIdToken().pipe(
      switchMap((token: string): Observable<HttpEvent<unknown>> => {
        if (matchingConfig === null) return next.handle(req);
        if (token === '' || flatSecureRoutes.length === 0) return next.handle(req);
        const authorized: HttpRequest<unknown> = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next.handle(authorized);
      }),
    );
  }

  private flatten(values: string[][]): string[] {
    return values.reduce((acc: string[], entry: string[]): string[] => acc.concat(entry), []);
  }

  private findMatchingConfig(url: string, configurations: OpenIdConfiguration[]): OpenIdConfiguration | null {
    for (const config of configurations) {
      for (const secureRoute of config.secureRoutes ?? []) {
        if (url.startsWith(secureRoute)) return config;
      }
    }
    return null;
  }
}
